import React from 'react'
import { Dropdown, Menu } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import * as DROPDOWN from 'constant/dropdown'
import PropTypes from 'prop-types'
import EditCategory from 'view/page/category-management/component/edit-category'
import DeleteCategory from 'view/page/category-management/component/delete-category'
import NewSubCategory from 'view/page/category-management/component/new-sub-category'
import formatInputs from 'helper/format-input-fields'
import styles from './styles'

const Action = ({ category }) =>
  (<span>
    <Dropdown
      overlay={
        <Menu >
          <Menu.Item>
            <EditCategory category={formatInputs(category)} />
          </Menu.Item>
          <Menu.Item>
            <DeleteCategory category={category} />
          </Menu.Item>
          <Menu.Item>
            <NewSubCategory categoryUuid={category.uuid} />
          </Menu.Item>
        </Menu>
      }
      overlayStyle={{ zIndex: 1 }}
      trigger={[DROPDOWN.TRIGGER]}
    >
      <div className={styles.show_more}>
        <span>More</span>
        <DownOutlined />
      </div>
    </Dropdown>
  </span>)

Action.propTypes = {
  category: PropTypes.object
}

export default Action
